var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('TixMessage',{attrs:{"type":"error","plain":_vm.error}}):_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }